/* eslint-disable */
"use strict";

import _ from "lodash";
import documenti from "@/services/documentiService.js";
import configurazioni from "@/services/configurazioniService.js";
import clienti from "@/services/clientiService.js";
import { fetchTO } from "@/components/helpers";

var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_reporting || process.env.VUE_APP_service_reporting;
})();

async function cicleSync() {
  try {
    const response = await fetch(`${service}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" }
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  try {
    const response = await fetchTO(`${service}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "REPORTING",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---"
  };
}

const stampaDocumento = async function(
  router,
  item,
  linkEsterno,
  newWindow,
  senzaPrezzi,
  tipo = "pdfm"
) {
  const documento = await documenti.getDocumento(item._id);
  if (documento) {
    const nomeReport =
      documento.tipoDocumento.nomeReport ||
      documento.tipoDocumento.tipoDocumento;
    // -------------------
    const elenco = await configurazioni.getConfigurazione("report", "report");
    const report = elenco.find(x => x.nomeReport === nomeReport);
    if (!report) {
      return { error: `Report non trovato: ${nomeReport}` };
    }
    let impostazioni = null;
    if (report.impostazioni) {
      if (typeof report.impostazioni === "string") {
        const conf = report.impostazioni.split(".");
        if (conf && conf.length === 2) {
          impostazioni = await configurazioni.getConfigurazione(
            conf[0],
            conf[1]
          );
        } else {
          impostazioni = report.impostazioni; // TODO: Verificare.
        }
      } else if (Array.isArray(report.impostazioni)) {
        impostazioni = {};
        for (const impo of report.impostazioni) {
          const conf = impo.split(".");
          if (conf && conf.length === 2) {
            impostazioni[conf[1]] = await configurazioni.getConfigurazione(
              conf[0],
              conf[1]
            );
          }
        }
      } else {
        impostazioni = report.impostazioni; // TODO: Verificare
      }
    }
    const codice =
      _.get(documento, "anagrafica.cliente.codice", "") ||
      _.get(documento, "anagrafica.fornitore.codice", "");
    const anagrafica = await clienti.getCliente(codice);
    const parametri = {
      caricaLoghi: report.caricaLoghi || false,
      autoPrint: report.autoPrint || false,
      reportHeader: report.reportHeader || null,
      pageHeader: report.pageHeader || null,
      pageFooter: report.pageFooter || null,
      reportFooter: report.reportFooter || null,
      intestazione: report.intestazione || null,
      filtri: null,
      impostazioni: impostazioni,
      anagrafica: anagrafica.recapiti,
      senzaPrezzi: senzaPrezzi || null
    };
    parametri.idDocumento = item._id;
    // -------------------
    const str = JSON.stringify(parametri);
    const buff = Buffer.from(str, "utf-8");

    const pathReportPrefix = config.service_reporting || "";
    // const tipo = 'pdfm'
    // TODO: Fare Mixin + da impostazioni decidere se usare viewer interno o aprire su browser (stessa pagina o pagina nuova)
    const token = JSON.parse(localStorage.getItem("token_bk"));
    const source = `${pathReportPrefix}/${tipo ||
      "pdfm"}/${nomeReport}?par=${buff.toString("base64")}&token=${token}`;
    if (source) {
      if (tipo === "base64") {
        const file = await base64Report(source);
        return file;
      } else {
        router
          .push({
            name: linkEsterno ? "Pdf-e" : "Pdf",
            params: { source: source, newWindow: newWindow }
          })
          .catch(() => {});
      }
    }
  }
};

async function base64Report(source) {
  // const source = `${pathReportPrefix}/${tipo || 'pdfm'}/${nomeReport}?par=${buff.toString('base64')}`
  try {
    const response = await fetch(source);
    return await response.json();
  } catch (err) {
    console.log("errore", err);
    return "";
  }
}

export default {
  cicleSync,
  getRunMode,
  stampaDocumento
};
